<template>
    <div class="header">
        <link rel="stylesheet" :href="themePath" />
        <Pixi @ready="ready" />
        <Circle top="0" left="0" class="move-1" />
        <Circle right="0" bottom="0" class="move-2"/>
    </div>

    <RouterView />

    <div class="footer">
        <ProfilePreview />
        <Navigation />
        <Player />
        
        <Messages />

        <div class="bottom-nav">
            <Select
                class="noerror inline icon-only"
                :optionList="locale.languages"
                :value="locale.locale"
                :clearable="false"
                :leftAuto="locale.rtl"
                :rightAuto="!locale.rtl"
                @change="onLanguageChange"
            />

            <Icon icon="exit" sprite="navigation" @click="logout" :title="t('nav.logout')" />
        </div>
    </div>
    <Modals />
</template>

<script setup>
import { computed, onMounted, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';

import ProfilePreview from './components/ProfilePreview/ProfilePreview.vue';
import Navigation from './components/Navigation/Navigation.vue';
import Player from './components/Player/Player.vue';
import Circle from '🔗/components/ui/Circle.vue';
import Messages from '🔗/components/ui/Messages.vue';
import Pixi from '🔗/components/ui/Pixi.vue';
import Modals from '@/components/modals/Modals.vue';
import Select from '🔗/components/ui/Select.vue';

import { storeToRefs } from 'pinia';
// import stores from '@/stores';
import { keepAwake } from '🔗/utils/utils'

const { t } = useI18n();
// const tg = stores.tg();
const others = stores.others();
const { themePath } = storeToRefs(others);
const user = stores.user();
const nav = stores.nav();
const locale = stores.locale();

const ready = async () => {
    others.setReady(true);
};

const onLanguageChange = (payload) => {
    locale.updateLocale(payload.value);
};

const logout = () => {
    user.logout();
    nav.open('login');
}

document.body.style['background-image'] = 'none';


onMounted(() => {
    document.addEventListener('visibilitychange', keepAwake);
    keepAwake();
});

onBeforeUnmount(() => {
    document.removeEventListener('visibilitychange', keepAwake);
});

</script>


<style scoped lang="scss">
    .header {
        margin-bottom: calc(-1 * var(--block-gap));
    }
    .footer {
        position: fixed;
        bottom: 0;
        left: 0;
        top: 0;
        width: 100%;
        z-index: 2;
        width: var(--nav-width);
        background: var(--dark-500);
        border-right: solid 1px var(--primary-20);
        gap: 32px;
        display: flex;
        flex-direction: column;
        overflow: auto;
        transition: transform .4s;
        @include scrollbar();

        .bottom-nav {
            margin: 12px 0 12px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            height: 42px;
            padding: 0 24px 0 12px;

            svg {
                fill: var(--white-80);
                cursor: pointer;
                width: 18px;
                height: 18px;
                // margin-left: auto;
                transition: all .4s;
                &:hover {
                    fill: var(--white-500);
                }
            }

        }
    }

    .direction-rtl {
        .footer {
            left: auto;
            right: 0;
            .bottom-nav {
                padding: 0 12px 0 24px;
            }
        }
    }
</style>
